/**
 * Brand colors
 */
export const corporateColors = {
  greyBlue: '#0e304f',
  // teal: 'rgb(0, 183, 195)',  PREVIOUS BRIGHTER TEAL. PLEASE KEEP FOR REFERENCE.
  teal: '#008383',
  gold: '#edae3c',
  grey: '#5c5962',
  lightGrey: '#e5dbd0',
};

export const corporateColorsHint = {
  build: '#f7f0ed',
  engage: '#f8f3f9',
  play: '#f4fcf9',
  manage: '#ebf6fa',
};

export const productCategoryColors = {
  blue: '#2c54b5',
  magenta: '#981f5f',
  green: '#128382',
  orange: '#cc4b17',
};
